<template>
    <div class="app-collection-view mt-3">
        <div class="row pb-3 border-bottom border-light">
            <div class="col text-left ml-2">
                <!-- <template v-if="previousPage.name == 'home'">
                    <router-link to="/">Home</router-link>
                </template>
                <template v-else-if="previousPage.name == 'category'">
                    <router-link :to="{ name: 'category', params: { cat: previousPage.params.cat}}">
                        {{ getCategoryName(previousPage.params.cat) }}
                    </router-link>
                </template>
                <template v-else-if="previousPage.name == 'browse'">
                    <router-link to="/browse">
                        All Collections
                    </router-link>
                </template> -->

                <router-link to="/browse">
                    All Collections
                </router-link>
                &nbsp;<span class="text-muted">&gt;</span>&nbsp;
                <router-link :to="{name: 'category', params: {cat: category.id}}">
                    {{category.name}}
                </router-link>
                &nbsp;<span class="text-muted">&gt;</span>&nbsp;
                <span class="text-muted">{{collection.title}}</span>
            </div>
        </div>
        <div class="row mt-4 pb-3">
            <div class="col text-left ml-2">
                <h3 class="mb-0"><span class="">Collection: </span> <strong>{{collection.title}}</strong></h3>
                <div class="text-muted">{{allGradients.length}} Gradients</div>
            </div>
        </div>
        <div class="row my-3" v-if="showColorFilter">
            <div class="col mx-2">
                <div class="filter-bar border border-light rounded shadow-sm">
                    <div class="color-filter ">
                        <template v-for="color in filterColors">
                            <div 
                                class="item" 
                                :style="{background : color.value}"
                                :key="color.name"
                                @click="updateFilter(color.name)"
                            >
                                <div v-if="activeFilter == color.name"><span class="times">&times;</span> CLEAR</div>
                            </div>
                        </template> 
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div 
                class="col-sm-6 col-md-6 col-lg-4 p-3 p-lg-4"
                v-for="gradient in filteredGradients"
                :key="gradient.date"
            >
                <gradient-box :gid="gradient.date" :cid="id" />
            </div>
        </div>
        <div class="row" v-if="premiumCollection">
            <div class="col-12 px-4">
                <div class="card border-0 shadow-sm rounded mb-5 mt-4 promo-bg">
                    <div class="promo-bar top mb-5"></div>
                    <h2><strong>{{collection.title}}</strong> is a Premium Collection</h2>
                    
                    <p v-if="isFree" class="mt-3 font-xl">
                        You can unlock all <strong>{{premiumTotalGradients}} Gradients</strong> and extra features for FREE by downloading the standalone bundle.
                    </p>
                    <p v-else class="mt-3 font-xl">
                        You can unlock all premium gradients and extra features by purchasing the complete bundle.
                        <!-- You can unlock all <strong>{{premiumTotalGradients}} Gradients</strong> and extra features by purchasing the complete bundle. -->
                    </p>

                    <p class="mt-3">
                        
                        <a class="btn btn-primary btn-lg px-5 mr-4" :href="premiumLink" target="_blank">
                            <template v-if="isFree">
                                Get The {{collection.title}} Bundle <span v-if="isFree" class="font-weight-bold">Free</span>
                            </template>
                            <template v-else>
                                Purchase the Complete Bundle
                            </template>
                        </a>
                        <router-link v-if="!isFree" to="/premium" class="btn btn-lg btn-link">Learn More</router-link>
                    </p>

                    <p class="mt-3 font-xl"><strong>Bonus Feature:</strong> Easy images - download gradients as images at any size or resolution.</p>

                    <div class="promo-bar bottom mt-5"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import collections from '@/util/collections.js'
import gradients from '@/util/gradients.js'
import categories from '@/util/categories.js'
import GradientBox from '@/components/GradientBox.vue'

// Used to save color filter state when people open a gradient
// (using route params was too messy)
let stickyColorFilter = null;

export default {
    components: {
        GradientBox
    },
    metaInfo(){
        return {
            title: "Gradient Collection: " + this.collectionName,
            meta: [
                { 
                    vmid:'description', 
                    name: 'description', 
                    content: `The ${this.collectionName} collection contains ${this.filteredGradients.length} CSS Gradients in a variety of colors and styles.` 
                }
            ],
            link: [
                { vmid: 'canonical', rel: 'canonical', href: 'https://www.gradientmagic.com/collection/' + this.collection.id }
            ]
        }
    },
    data(){
        return {
                defaultFilterColors : [
                    { name : 'red', value : '#EB4141' },
                    { name: 'brown', value: '#b16f03' },
                    { name : 'orange', value : '#EB9641' },
                    { name : 'yellow', value : '#E8EB41' },
                    { name : 'green', value : '#4DEB41' },
                    { name : 'blue', value : '#41BBEB' },
                    { name : 'purple', value : '#6641EB' },
                    { name : 'pink', value : '#E241EB'},
                    { name : 'bw', value : 'linear-gradient(90deg, white, black)'},
                    { name : 'rainbow', value: 'linear-gradient(90deg, hsl(325,89%,68%, 1) 0%, hsl(325,89%,68%, 1) 12.5%,hsl(10,89%,68%, 1) 12.5%, hsl(10,89%,68%, 1) 25%,hsl(55,89%,68%, 1) 25%, hsl(55,89%,68%, 1) 37.5%,hsl(100,89%,68%, 1) 37.5%, hsl(100,89%,68%, 1) 50%,hsl(145,89%,68%, 1) 50%, hsl(145,89%,68%, 1) 62.5%,hsl(190,89%,68%, 1) 62.5%, hsl(190,89%,68%, 1) 75%,hsl(235,89%,68%, 1) 75%, hsl(235,89%,68%, 1) 87.5%,hsl(280,89%,68%, 1) 87.5%, hsl(280,89%,68%, 1) 100%)'}
                ],
                activeFilter: null,
                // previousPage: null
        }
    },
    methods: {
        updateFilter(color){
            if(this.activeFilter == color) {
                this.activeFilter = null
                stickyColorFilter = null;
            }
            else {
                this.activeFilter = color;
                stickyColorFilter = color;
            }
        },
        getCategoryName(cat){
            let category = categories.find((obj) => obj.id == cat)
            return category.name;
        }
    },
    computed: {
        id(){
            return this.$route.params.cid;
        },
        collection(){
            return collections.find((obj)=>{
                return obj.id == this.id
            })
        },
        collectionName(){ 
            return this.collection.title;
        },
        premiumLink(){
            if(this.collection.premium) return this.collection.config.link
            return ''
        },
        premiumTotalGradients(){
            if(this.collection.premium) return this.collection.config.gradients;
            return 0
        },
        isFree(){
            if(this.collection.premium) return this.collection.config.free;
            return false
        },
        premiumCollection(){
            return this.collection.premium;
        },
        category(){
            let primaryCategory = this.collection.categories[0];
            return categories.find((cat) => cat.id == primaryCategory);
        },
        filteredGradients(){
            if(!this.activeFilter || !this.showColorFilter) return this.allGradients
            return this.allGradients.filter((obj) => {
                return obj.tags.includes(this.activeFilter)
            })
        },
        allGradients(){
            // return gradients.filter((obj) => {
            //     return obj.tags.includes(this.collection.id)
            // });

            // Show most recent first
            return gradients.filter((obj) => {
                return obj.tags.includes(this.collection.id)
            }).sort((c1,c2) => {
                return c2.date - c1.date;
            });
        },
        showColorFilter(){
            return this.collection.config.colorFilter
        },
        // previousPage(){
        //     console.log(stickyPreviousPage)
        //     return stickyPreviousPage;
        // },
        filterColors(){            
            return this.defaultFilterColors.filter((color) => {
                for(let i=0; i< this.allGradients.length; i++){
                    if(this.allGradients[i].tags.includes(color.name)) return true;
                }
                return false;
            })
        }
    },
    watch: {
        id: function(oldVal, newVal){
            // stickyPreviousPage = null;
            stickyColorFilter = null;
            this.activeFilter = null;
        }
    },
    beforeRouteEnter(to, from, next){
        
        // if(from.name != 'gradient') stickyPreviousPage = from;

        next(vm => {
            if(from.name == 'gradient' && stickyColorFilter && vm.showColorFilter){
                vm.activeFilter = stickyColorFilter;
            }
            else if(from.name != 'gradient'){
                stickyColorFilter = null;
                window.scrollTo(0,0);
            }
        })
    }
}
</script>

<style lang="scss">
.app-collection-view {
  $min-width-md: 768px;

  .promo-bar {
      height: 6px;
      width: 100%;
      &.top {
          border-radius: 4px 4px 0 0;
      }
      &.bottom {
          border-radius: 0 0 4px 4px;
      }
      background-image: repeating-linear-gradient(90deg, hsl(355,77%,74%) 0px, hsl(355,77%,74%) 70px,hsl(40,77%,74%) 70px, hsl(40,77%,74%) 140px,hsl(85,77%,74%) 140px, hsl(85,77%,74%) 210px,hsl(130,77%,74%) 210px, hsl(130,77%,74%) 280px,hsl(175,77%,74%) 280px, hsl(175,77%,74%) 350px,hsl(220,77%,74%) 350px, hsl(220,77%,74%) 420px,hsl(265,77%,74%) 420px, hsl(265,77%,74%) 490px,hsl(310,77%,74%) 490px, hsl(310,77%,74%) 560px);

  }

  .color-filter {
    padding: 15px;
    display: flex;

    .item {
            height: 30px;
            cursor: pointer;
            flex: 1;
            border-radius: 3px;
            margin: 0 6px;
            border: 1px solid #333;

            @media (max-width: $min-width-md){
                margin: 0 3px;
            }

            >div {
                .times {
                    font-size: 130%;
                }
            background: rgba(0,0,0,.4);
            background: linear-gradient(135deg, transparent 0%, transparent 16%,rgba(247, 247, 247, 0.84) 16%, rgba(247, 247, 247, 0.84) 100%);
            color: #111;
            text-align: center;
            line-height: 28px;
            text-transform: uppercase;
            font-size: 80%;
            height: 28px;
            border-radius: 3px
            }
        }
    }

    .breadcrumb {
        font-size: 85%;
    }

    .promo-bg {
        // background-image: repeating-linear-gradient(299deg, rgb(255,255,255) 0px, rgb(255,255,255) 20px,transparent 20px, transparent 22px),repeating-linear-gradient(0deg, rgb(255,255,255) 0px, rgb(255,255,255) 20px,transparent 20px, transparent 22px),repeating-linear-gradient(266deg, rgb(255,255,255) 0px, rgb(255,255,255) 20px,transparent 20px, transparent 22px),linear-gradient(90deg, rgb(229, 161, 5),rgb(72, 215, 30));
        background-image: radial-gradient(circle at center center, transparent,rgb(255,255,255)),repeating-linear-gradient(135deg, rgba(133, 133, 133,0.06) 0px, rgba(133, 133, 133,0.06) 2px,transparent 2px, transparent 4px),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
        // background-image: linear-gradient(90deg, transparent 0%,rgb(255,255,255) 14%,rgb(255,255,255) 86%,transparent 100%),repeating-linear-gradient(90deg, rgba(98, 98, 98,0.06) 0px, rgba(98, 98, 98,0.06) 1px,transparent 1px, transparent 5px),repeating-linear-gradient(0deg, rgba(98, 98, 98,0.06) 0px, rgba(98, 98, 98,0.06) 1px,transparent 1px, transparent 5px),repeating-linear-gradient(0deg, rgba(98, 98, 98,0.06) 0px, rgba(98, 98, 98,0.06) 1px,transparent 1px, transparent 15px),repeating-linear-gradient(90deg, rgba(98, 98, 98,0.06) 0px, rgba(98, 98, 98,0.06) 1px,transparent 1px, transparent 15px),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
    }

}
</style>